import { object as yupObject, string as yupString } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import TranslationMessage from './transMessage'
import { requiredWithoutSpaces } from '../../../utils/regex.utils';

export interface IPersonalFormDefaultProps {
    first_name: string;
    last_name: string;
    email_address?: string;
    phone_number: string;
}

const personalFormDefaults: IPersonalFormDefaultProps = {
    first_name: '',
    last_name: '',
    email_address: '',
    phone_number: ''
};

const schema = (t: any) => yupObject({
    first_name: yupString()
        .matches(/^[^\d]+$/, t(TranslationMessage.ERROR_FIRST_NAME))
        .matches(requiredWithoutSpaces(), t(TranslationMessage.ERROR_FIRST_NAME)) 
        .min(2, t(TranslationMessage.ERROR_FIRST_NAME))
        .max(50, t(TranslationMessage.ERROR_FIRST_NAME))
        .required(t(TranslationMessage.ERROR_FIRST_NAME)),
    last_name: yupString()
        .matches(/^[^\d]+$/, t(TranslationMessage.ERROR_LAST_NAME))
        .matches(requiredWithoutSpaces(), t(TranslationMessage.ERROR_LAST_NAME)) 
        .min(2, t(TranslationMessage.ERROR_LAST_NAME))
        .max(50, t(TranslationMessage.ERROR_LAST_NAME))
        .required(t(TranslationMessage.ERROR_LAST_NAME)),
    phone_number: yupString()
        .nullable()
        .notRequired()
        .matches(
            /^\(\d{3}\) \d{3}-\d{4}$/,
            t(TranslationMessage.ERROR_PHONE_NUMBER)
        )
        .transform((value) => (value === "" ? null : value))
});

const personalFormSchema = (t: any) => yupResolver(schema(t));

const formatPreferredCommunication = (param: any) => {
    const value = param === "SMS (Text)" ? "SMS" : param
    return value?.toUpperCase()
}

export {
    personalFormDefaults,
    personalFormSchema,
    formatPreferredCommunication
}